import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferralNote } from '@principle-theorem/principle-core';
import {
  IReferral,
  IReferralNote,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef, isWithRef } from '@principle-theorem/shared';
import { ReferralService } from './referral.service';

@Injectable()
export class ReferralNoteService {
  private _referralService = inject(ReferralService);
  private _snackBar = inject(MatSnackBar);

  async upsert(
    referral: WithRef<IReferral>,
    note: IReferralNote | WithRef<IReferralNote>
  ): Promise<void> {
    const saveStartTime = this._referralService.startSaving();
    try {
      if (isWithRef(note)) {
        await Firestore.patchDoc(note.ref, { content: note.content });
      } else {
        await Firestore.addDoc(ReferralNote.col(referral), { ...note });
      }
    } catch {
      this._snackBar.open('Error with referral note operation');
    } finally {
      await this._referralService.stopSaving(saveStartTime);
    }
  }

  async delete(note: WithRef<IReferralNote>): Promise<void> {
    try {
      await Firestore.deleteDoc(note.ref);
    } catch {
      this._snackBar.open('Error deleting referral note');
    }
  }
}
